module.exports = __webpack_public_path__ + "img/FIRST_QUARTER.fc5be510.png";